import Icon from 'Components/_NewElements/Icon';

const LeftRightControls = ({ action, disabled }: IOwnProps) => {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        userSelect: 'none',
        marginBottom: '0.3rem',
      }}
    >
      <Icon
        icon="leftMoveArrow"
        round
        button
        onClick={action.left}
        disabled={disabled.left}
        color={disabled.left ? 'gray' : undefined}
      />
      <Icon
        icon="rightMoveArrow"
        round
        button
        onClick={action.right}
        disabled={disabled.right}
        color={disabled.right ? 'gray' : undefined}
      />
    </div>
  );
};

interface IOwnProps {
  action: { left: () => void; right: () => void };
  disabled: { left: boolean; right: boolean };
}

export default LeftRightControls;
